export default __webpack_public_path__ + "static/media/464.930badb0.png";